import { useState } from "react";
import { BaseService } from "@services/BaseService";
import environment from "environment";
import type { OrganisationInfoAddRequestV1 } from "@ucchub/ui/src/apiTypes/cloudNumbers";
import type { AccountConfigAddRequest } from "@components/accountConfiguration/AccountConfig.types";

const useCreateEditAccountConfig = () => {
  const [isAccountConfigSubmitting, setIsAccountConfigSubmitting] =
    useState(false);

  const [error, setError] = useState<string>();

  const submitCreateAccountConfig = (data: OrganisationInfoAddRequestV1) => {
    return new Promise(function (resolve, reject) {
      setIsAccountConfigSubmitting(true);
      setError("");
      const apiUrl = environment.api.organisationInfo;

      BaseService.post<OrganisationInfoAddRequestV1>(apiUrl, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          setError(err?.message);
          reject(err?.message);
        })
        .finally(() => {
          setIsAccountConfigSubmitting(false);
        });
    });
  };

  const submitEditAccountConfig = (
    data: AccountConfigAddRequest,
    orgId: string
  ) => {
    return new Promise(function (resolve, reject) {
      setIsAccountConfigSubmitting(true);
      setError("");
      const apiUrl = environment.api.organisationInfo + `/${orgId}`;

      BaseService.patch(apiUrl, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          setError(err?.message);
          reject(err?.message);
        })
        .finally(() => {
          setIsAccountConfigSubmitting(false);
        });
    });
  };

  return {
    isAccountConfigSubmitting,
    submitCreateAccountConfig,
    submitEditAccountConfig,
    error,
  };
};

export default useCreateEditAccountConfig;
